<!--
 * @Author: chengleilei
 * @Date: 2025-09-26 15:11:02
 * @Description: 非轮订单-已发货
-->
<template>
    <Card :bordered="false" dis-hover>
        <table-form :formList="formList" ref="table-form" @on-submit="onSubmit" @on-export="exportInfo">
            <Button class="ivu-ml-8" slot="extraBtn" type="error">导出</Button>
        </table-form>
        <table-page :list="tableConfig" @oinPageChange="onPageChange" @onPageSizeChange="onPageSizeChange" />

        <RefundModal ref="refundModalRef" @confirmOk="getData" />
        <RecordModal ref="recordModalRef" />
        <ViewLogisticsModal ref="viewLogisticsModalRef" />
    </Card>
</template>
<script>
import tablePage from '@/components/tablePage';
import tableForm from '@/components/tableForm';
import RefundModal from './components/RefundModal';
import RecordModal from './components/RecordModal';
import ViewLogisticsModal from './components/ViewLogisticsModal';
import { clearInvalidKey } from '@/libs/util.tool';
import { renderButton } from '@/libs/util';
import { apiNonwheelOrderList, apiNonwheelOrderExport } from '@/api/purchase';
import { sendFormList, sendColumns } from './const';

export default {
    components: { tableForm, tablePage, RefundModal, RecordModal, ViewLogisticsModal },
    data() {
        return {
            tableConfig: {
                current: 1,
                size: window.$pageSize,
                total: 0,
                noDataText: '暂无订单',
                columns: [
                    ...sendColumns,
                    {
                        title: '操作',
                        align: 'center',
                        width: 220,
                        fixed: 'right',
                        render: (h, p) => {
                            return [
                                p.row.canRefund &&
                                    renderButton(h, { text: '退款', type: 'error' }, () => {
                                        this.onRefundBtnClick(p.row);
                                    }),
                                (p.row.refundStatus > 0 || p.row.hasRefunding) &&
                                    renderButton(h, { text: '退款单', type: 'warning' }, () => {
                                        this.onRecordBtnClick(p.row);
                                    }),
                                renderButton(
                                    h,
                                    { text: '查看物流', type: 'warning', disabled: !p.row.logisticsNo },
                                    () => {
                                        this.onCheckBtnClick(p.row);
                                    },
                                ),
                            ];
                        },
                    },
                ],
                data: [],
                loading: false,
            },
            formList: sendFormList,
        };
    },
    activated() {
        // this.getData();
    },
    methods: {
        // 设置品牌商筛选项
        renderOptions(brandingCompanyList) {
            this.formList[7].options = brandingCompanyList;
        },
        // 获取参数
        getParams() {
            let p = this.$refs['table-form'].getFormData();
            const copyP = { ...clearInvalidKey(p) };
            copyP.status = 1002;
            const params = {
                current: this.tableConfig.current,
                size: this.tableConfig.size,
                ...copyP,
            };
            return params;
        },
        // 获取数据
        async getData() {
            try {
                this.tableConfig.loading = true;
                const res = await apiNonwheelOrderList(this.getParams());
                this.tableConfig.total = Number(res.total);
                this.tableConfig.data = (res.records || []).map((item) => {
                    return {
                        ...item,
                        activitySn: item.itemList[0].activitySn || '-',
                        amount: item.itemList[0].amount || '-',
                        brandName: item.itemList[0].brandName || '-',
                        company: item.itemList[0].company || '-',
                        orderId: item.itemList[0].orderId || '-',
                        productName: item.itemList[0].productName || '-',
                        quantity: item.itemList[0].quantity || '-',
                        skuSpec: item.itemList[0].skuSpec || '-',
                    };
                });
            } finally {
                this.tableConfig.loading = false;
            }
        },
        // 页码改变
        onPageChange(val) {
            this.tableConfig.current = val;
            this.getData();
        },
        // x条/页改变
        onPageSizeChange(val) {
            this.tableConfig.current = 1;
            this.tableConfig.size = val;
            this.getData();
        },
        // 查询
        onSubmit() {
            this.tableConfig.current = 1;
            this.getData();
        },
        // 导出
        async exportInfo() {
            try {
                this.$Message.loading({ content: '导出中...', duration: 0 });
                await apiNonwheelOrderExport(this.getParams());
                this.$Modal.confirm({
                    title: '提示',
                    content: `您好！“${this.$route.meta.title}”正在导出，请稍后在“导出列表”模块中查看，谢谢！`,
                    onOk: () => {
                        console.log('export');
                    },
                });
            } finally {
                this.$Message.destroy();
            }
        },
        // 查看物流
        onCheckBtnClick(row) {
            this.$refs['viewLogisticsModalRef'].open(row);
        },
        // 退款
        onRefundBtnClick(row) {
            this.$refs['refundModalRef'].open(row);
        },
        // 退款单
        onRecordBtnClick(row) {
            this.$refs['recordModalRef'].open(row);
        },
    },
};
</script>
